import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const BillingSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.54969 16.4932H7.72633C8.24782 16.4932 8.59924 16.1417 8.59924 15.6429V13.9956C8.59924 13.4968 8.24782 13.1454 7.72633 13.1454H5.54969C5.0282 13.1454 4.67675 13.4968 4.67675 13.9956V15.6429C4.67675 16.1417 5.0282 16.4932 5.54969 16.4932ZM2.32451 9.89196H21.7919V7.8865H2.32451V9.89196ZM4.371 19.5H19.7235C21.5215 19.5 22.4211 18.5977 22.4211 16.8302V7.1698C22.4211 5.4023 21.5215 4.5 19.7235 4.5H4.371C2.58083 4.5 1.66992 5.39527 1.66992 7.1698V16.8302C1.66992 18.6047 2.58083 19.5 4.371 19.5ZM4.39368 18.24C3.44741 18.24 2.92989 17.7382 2.92989 16.7606V7.23941C2.92989 6.26184 3.44741 5.75997 4.39368 5.75997H19.7008C20.6295 5.75997 21.1646 6.26184 21.1646 7.23941V16.7606C21.1646 17.7382 20.6295 18.24 19.7008 18.24H4.39368Z"
        fill={color}
      />
    </svg>
  );
};

export { BillingSvg };
